
import { Component, Prop, Vue } from 'vue-property-decorator';

import CurbsideSvg from '@/components/CurbsideSvg.vue';
import DeliverySvg from '@/components/DeliverySvg.vue';
import PickupSvg from '@/components/PickupSvg.vue';
import { OrderMethods } from '@/enums';

@Component({
  components: {
    DeliverySvg,
    CurbsideSvg,
    PickupSvg,
  },
  model: {
    prop: 'modelValue',
    event: 'change',
  }
})
export default class ChooseOrderMethod extends Vue {
  @Prop() modelValue: any;

  get orderMethods() {
    return Object.values(OrderMethods).filter((method) => method !== OrderMethods.DISPATCH);
  }

  get selectedMethod() {
    return this.modelValue || null;
  }
}
